import { 
  SET_DATA_TAG_ALL_REPORTS,
  SET_DATA_TAG_REPORTS_LOADER,
  SET_DATA_TAG_SNACKBAR,
  CLEAR_DATA_TAG_SNACKBAR,
  SET_DATA_TAG_CONTENT_ACTION,
} from "../../features/Data Tag/DataTagConstants";

const initialState = {
  allReports: { reports: [], totalElements: 0 }, // paginated API envelope
  loader: false,
  snackBarMessage: {},
  // Tracks which report/action (preview | print | download) is currently
  // in flight, so only that row's icon shows a loading state.
  contentAction: { reportId: null, mode: null },
}

export const DataTagReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA_TAG_ALL_REPORTS: {
      return {
        ...state,
        allReports: action.payload
      }
    }
    case SET_DATA_TAG_REPORTS_LOADER: {
      return {
        ...state,
        loader: action.payload
      }
    }
    case SET_DATA_TAG_SNACKBAR: {
      return {
        ...state,
        snackBarMessage: action.payload
      }
    }
    case CLEAR_DATA_TAG_SNACKBAR: {
      return {
        ...state,
        snackBarMessage: {}
      }
    }
    case SET_DATA_TAG_CONTENT_ACTION: {
      return {
        ...state,
        contentAction: action.payload
      }
    }
    default:
      return state;
  }
}